import template from './createPOPModal.html';
import controller from './createPOPModal.controller';

let CreatePOPModalComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  size: 'md',
  windowClass: "hmodal-info animated zoomIn"
};

// Export template and controller separately for use with $uibModal.open()
CreatePOPModalComponent.template = template;
CreatePOPModalComponent.controller = controller;

export default CreatePOPModalComponent;




// WEBPACK FOOTER //
// ./client/common/modals/createPOPModal/createPOPModal.component.js